import type { SocialRule, SocialRuleChannelScope } from './types';

/**
 * Rebuild the scope the server stores from the picked channel ids.
 *
 * A channel that has since been disconnected is no longer in `channels`, so its platform is taken
 * from the scope the rule already carries. Defaulting it to Instagram would silently re-platform a
 * Facebook Page on the next save.
 */
export const buildChannelScope = (
	channelIds: string[],
	channels: { channelId: string; platform: 'facebook' | 'instagram' }[],
	rule: SocialRule | null
): SocialRuleChannelScope[] =>
	channelIds.map((channelId) => ({
		channelId,
		platform:
			channels.find((channel) => channel.channelId === channelId)?.platform ??
			rule?.channelScope.find((scope) => scope.channelId === channelId)?.platform ??
			'instagram'
	}));
